<template>
    <IdeoFormGroup :label="$t('[[[Tytuł]]]')" :invalid-feedback="form.$errors.first('title')" :state="form.$errors.state('title')" required>
        <IdeoFormInput v-model="form.title" type="text" name="title" counter-mode="remaining" max-chars="128" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Powiązane szkolenie]]]')">
        <div class="d-flex flex-column flex-md-row">
            <div class="flex-grow-1">
                <IdeoAutocomplete
                    v-model="form.contents.powiazane_szkolenie"
                    name="trainingId"
                    track-by="id"
                    :placeholder="$t('[[[zacznij pisać aby wyszukać szkolenie...]]]')"
                    :fetch="(id: number) => fetchTraining(id)"
                    :search="(query: string, limit: number) => searchTrainings(query, limit)"
                    :refresh="true"
                >
                    <template #selected="{ option }">
                        <div class="text-wrap">
                            {{ option.title }}
                        </div>
                    </template>
                    <template #option="{ option }">
                        <div class="text-wrap">
                            {{ option.title }}
                        </div>
                    </template>
                </IdeoAutocomplete>
            </div>
        </div>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Dostępne szkolenia]]]')">
        <div class="list-group">
            <div v-for="item in availableTrainingsList" :key="item.id" class="list-group-item list-group-item-action p-2 d-flex align-items-center" @click="moveToSelected(item.id)">
                <i class="far fa-fw fa-newspaper text-primary me-2" />
                <span class="flex-grow-1"><b class="ms-2">{{ item.title }}</b></span>
            </div>
            <div v-if="availableTrainingsList.length === 0" class="list-group-item list-group-item-light text-center">
                {{ $t('[[[Brak dostępnych szkoleń]]]') }}
            </div>
        </div>
    </IdeoFormGroup>
</template>

<script lang="ts" setup>
import merge from 'lodash/merge';
import type { ListItemModel as TrainingsListItemModel } from '#layers/prawopl/app/pages/cms/modules/wk-trainings/_runtime/services/TrainingsService';
import TrainingsService from '#layers/prawopl/app/pages/cms/modules/wk-trainings/_runtime/services/TrainingsService';

defineOptions({
    name: 'TrainingTypeSettings'
});

const { $t } = useLocalization();

const props = defineProps<{
    modelValue: any;
    websiteId: number;
    locale: string;
    id: number;
}>();

const defaults = { powiazane_szkolenie: null as number | null };

const emit = defineEmits<{
    (event: 'update:modelValue', value: any): void;
}>();

const form = ref(props.modelValue);

const trainingId = ref<number | null>(null);

const availableTrainingsList = ref<TrainingsListItemModel[]>([]);

function moveToSelected(trainingId: number)
{
    const training = availableTrainingsList.value.find(a => a.id === trainingId);

    if (!training) return;

    form.value.contents.powiazane_szkolenie = training.id;
}

async function fetchTraining(id: number): Promise<TrainingsListItemModel>
{
    const response = await TrainingsService.fetchAutocomplete(id);

    return response || null;
}

async function searchTrainings(query: string, limit: number): Promise<TrainingsListItemModel[]>
{
    return await TrainingsService.getAutocomplete(query, limit);
}

onMounted(async () =>
{
    form.value.contents = merge(defaults, form.value.contents);

    trainingId.value = form.value.contents.powiazane_szkolenie;

    availableTrainingsList.value = await TrainingsService.getAutocomplete('', 100);
});

watch(() => form.value.contents, () =>
{
    triggerModel();
}, { deep: true });

function triggerModel()
{
    emit('update:modelValue', form.value);
}
</script>
